import React from 'react';
import { Button, ButtonGroup } from "react-bootstrap";

const Row = ({ factor, onRemove }) => {
    return (<tr>
        <td style={{ textAlign: 'left' }}>{factor.country}</td>
        <td>{factor.factor}</td>
        <td>
            <ButtonGroup>
                <Button bsStyle="danger" onClick={() => onRemove(factor.country)}>Remove</Button>
            </ButtonGroup>
        </td>
    </tr>);
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/PushapiCountry/components/Table/components/Row/index.js